// extracted by mini-css-extract-plugin
export default {"goalsContainer":"LoanGoals_goalsContainer__uX9Vt","skeletonLoadingAnimation":"LoanGoals_skeletonLoadingAnimation__8xKLP"};